const STORAGE_KEY = 'admin-panel';
const BACKEND_VERSION_HEADER = 'x-backend-version';

export { STORAGE_KEY, BACKEND_VERSION_HEADER };
